import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { siteConfig, navigationLinks, relatedKeywords } from '../data/mock';

const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const whatsappLink = `https://wa.me/${siteConfig.phone}?text=${encodeURIComponent(siteConfig.whatsappDefault)}`;

  return (
    <footer className="bg-[#050810] border-t border-gray-800/50">
      <div className="container mx-auto px-6 md:px-8 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            {/* Company Info */}
            <div className="space-y-4 lg:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div className="flex flex-col">
                  <span className="text-white font-bold text-lg leading-tight">{siteConfig.companyName}</span>
                  <span className="text-blue-400 text-xs uppercase tracking-wider">Rastreamento Veicular Sorocaba</span>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed max-w-md">
                Empresa especializada em rastreamento veicular em Sorocaba/SP. Monitoramento 24h, bloqueio remoto, app completo e suporte técnico local. 
                Proteção para veículos pessoais e frotas empresariais.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <h3 className="text-gray-400 font-semibold text-sm mb-4 uppercase tracking-wider">Navegação</h3>
              <ul className="space-y-2">
                {navigationLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      onClick={(e) => scrollToSection(e, link.href)}
                      className="text-gray-500 hover:text-blue-400 transition-colors text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="text-gray-400 font-semibold text-sm mb-4 uppercase tracking-wider">Contato</h3>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                  </svg>
                  <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:text-green-400 transition-colors text-sm"
                  >
                    (15) 99192-7177
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-500 text-sm">{siteConfig.address}</p>
                </li>
                <li className="flex items-start gap-3">
                  <Clock className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-500 text-sm">Suporte 24h - 7 dias por semana</p>
                </li>
              </ul>
            </div>
          </div>

          {/* Related Keywords */}
          <div className="border-t border-gray-800/50 pt-6 mb-6">
            <div className="flex flex-wrap gap-2">
              {relatedKeywords.map((keyword, index) => (
                <span
                  key={index}
                  className="bg-gray-900/50 border border-gray-800 text-gray-600 text-xs px-3 py-1 rounded-full"
                >
                  {keyword}
                </span>
              ))}
            </div>
          </div>

          {/* Bottom */}
          <div className="border-t border-gray-800/50 pt-6">
            <div className="text-center text-gray-600 text-xs">
              <p>© 2026 GoProtege - Rastreamento Veicular em Sorocaba/SP. Todos os direitos reservados.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
